import { dataGridSortDirection } from '@shared/components';
import { parseAsPageNumber } from '@shared/utils';
import { parseAsInteger, parseAsString, parseAsStringLiteral, useQueryStates } from 'nuqs';

export function useExamCourseSearchParams() {
  return useQueryStates(
    {
      search: parseAsString.withDefault(''),
      page: parseAsPageNumber.withDefault(0),
      pageSize: parseAsInteger.withDefault(10),
      field: parseAsString.withDefault('examId'),
      sort: parseAsStringLiteral(dataGridSortDirection).withDefault('asc'),
      group: parseAsString.withDefault(''),
    },
    {
      urlKeys: {
        search: 'q',
      },
    },
  );
}
